import getStore from '../store/appHostSearchStore';

export default (): boolean => getStore().isSearchEnabled;
